import { Component, computed, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { resolveStoredIcon } from '../../utils/stored-icon';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IconComponent {
  readonly icon = input<string | null | undefined>('');
  readonly fallback = input<string>('business-outline');
  readonly size = input<number>(16);
  readonly color = input<string>('currentColor');

  readonly resolved = computed(() => resolveStoredIcon(this.icon(), this.fallback()));
}
